import countryList from "react-select-country-list";

export const getCountryLabel = (countryCode: string) =>
  countryCode ? countryList().getLabel(countryCode) : "";
